// Feelgood PDP: Mengen-Spinner auch für VARIANTEN-Artikel.
//
// Kundenwunsch 2026-10-21: die Detailansicht von Varianten-Artikeln hatte
// keinen Mengen-Spinner (der Webshop rendert ihn nur für Artikel ohne
// Varianten). Der Configurator (item_configure.js) legt ausschliesslich
// Statuszeile + "Artikel hinzufuegen" an und schickt fest qty: 1.
//
// Dieses Skript (SCOPE: nur Shop-Seiten, Marker .product-page-content):
//  1. beobachtet den Varianten-Status, sobald eine exakte Variante gefunden
//     ist (".variant-item-code" + ".btn-variant-add-to-cart"),
//  2. holt die Mengen-Regeln der Variante (custom_lot_size /
//     custom_min_sales_quantity) ueber
//     webshop.webshop.shopping_cart.product_info.get_product_info_for_website,
//  3. baut denselben Spinner-Aufbau wie bei Nicht-Varianten
//     (.item-qty-area .number-spinner mit .item-qty, data-min-qty,
//     data-lot-size) und die Buttons in eine zentrierte Reihe,
//  4. haengt sich in webshop.webshop.shopping_cart.update_cart: der
//     Configurator ruft mit qty: 1 - bei passender Variante ersetzen wir das
//     durch die gewaehlte Menge (Notes/Attribute bleiben unberuehrt),
//  5. zeigt in der Statuszeile die SUMME (Einzelpreis x Menge) und daneben
//     den Einzelpreis "(€ 29,80 / Stk)" - konsistent zur Nicht-Varianten-PDP.
//
// Die +/- -Klicks und die Eingabe-Validierung erledigt der Webshop selbst
// (delegierte Handler auf .page_content fuer .item-qty-area), hier wird nur
// nachgerechnet.
(function () {
	var SEL_STATUS = ".product-page-content .variant-status-area";
	var SEL_CODE = ".variant-item-code";
	var SEL_BTN = ".btn-variant-add-to-cart";
	var SEL_PRICE = ".variant-price";
	var SEL_QTY_ROW = ".fg-variant-qty";
	var RULES_METHOD = "webshop.webshop.shopping_cart.product_info.get_product_info_for_website";

	var state = { itemCode: null, unitText: null, min: 1, lot: 1 };
	var hooked = false;

	function parseMoney(text) {
		var m = (text || "").replace(/\s/g, "").match(/-?[\d.,]+/);
		if (!m) return null;
		var s = m[0];
		if (s.indexOf(",") > -1) {
			s = s.replace(/\./g, "").replace(",", ".");
		}
		var v = parseFloat(s);
		return isNaN(v) ? null : v;
	}

	function formatMoney(unitText, value) {
		var currency = (unitText.match(/^[^\d,.]+/) || [""])[0].trim();
		return currency + (currency ? " " : "") + value.toFixed(2).replace(".", ",");
	}

	function spinnerInput() {
		return document.querySelector(SEL_STATUS + " " + SEL_QTY_ROW + " input.item-qty");
	}

	function readQty() {
		var input = spinnerInput();
		var qty = input ? parseInt(input.value, 10) || 0 : 0;
		return qty > 0 ? qty : state.min;
	}

	/* Statuszeile: Summe gross, Einzelpreis als Hinweis daneben */
	function renderPrice() {
		var priceEl = document.querySelector(SEL_STATUS + " " + SEL_PRICE);
		if (!priceEl || !state.unitText) return;

		var unit = parseMoney(state.unitText);
		if (unit === null) return;

		var qty = readQty();
		var totalText = formatMoney(state.unitText, unit * qty);
		var hintText = "(" + state.unitText + " / Stk)";
		var wanted = totalText + '\t<small class="fg-variant-unit">' + hintText + "</small>";

		if (priceEl.dataset.fgTotal !== totalText) {
			priceEl.innerHTML = wanted;
			priceEl.dataset.fgTotal = totalText;
		}
	}

	function buildSpinner() {
		var area = document.createElement("div");
		area.className = "fg-variant-qty item-qty-area";
		area.innerHTML =
			'<div class="input-group number-spinner" style="width: 130px;">' +
			'<span class="input-group-prepend">' +
			'<button type="button" class="item-qty-btn dwn-qty" data-dir="dwn">&ndash;</button>' +
			"</span>" +
			'<input class="form-control text-center item-qty" value="' + state.min + '" min="' + state.min +
			'" step="' + state.lot + '" data-min-qty="' + state.min + '" data-lot-size="' + state.lot + '">' +
			'<span class="input-group-append">' +
			'<button type="button" class="item-qty-btn up-qty" data-dir="up">+</button>' +
			"</span>" +
			"</div>";
		return area;
	}

	function applyRules() {
		var input = spinnerInput();
		if (!input) return;
		input.min = state.min;
		input.step = state.lot;
		input.setAttribute("data-min-qty", state.min);
		input.setAttribute("data-lot-size", state.lot);
		var current = parseInt(input.value, 10) || 0;
		if (current < state.min) {
			input.value = state.min;
		}
	}

	function loadRules(itemCode) {
		frappe.call({
			method: RULES_METHOD,
			args: { item_code: itemCode, skip_quotation_creation: 1 },
			callback: function (r) {
				var info = r.message && r.message.product_info;
				state.min = (info && parseInt(info.min_qty, 10)) || 1;
				state.lot = (info && parseInt(info.lot_size, 10)) || 1;
				if (state.itemCode === itemCode) {
					applyRules();
					renderPrice();
				}
			},
		});
	}

	/* Spinner + Button in eine Reihe setzen */
	function ensureSpinner() {
		var status = document.querySelector(SEL_STATUS);
		if (!status) return;

		var codeEl = status.querySelector(SEL_CODE);
		var itemCode = codeEl ? codeEl.textContent.trim() : "";
		var btn = status.querySelector(SEL_BTN);

		if (!itemCode || !btn) {
			// keine exakte Variante (noch) gewaehlt
			var stale = status.querySelector(SEL_QTY_ROW);
			if (stale) stale.remove();
			state.itemCode = null;
			state.unitText = null;
			return;
		}

		if (itemCode !== state.itemCode) {
			state.itemCode = itemCode;
			var priceEl = status.querySelector(SEL_PRICE);
			state.unitText = priceEl ? priceEl.textContent.trim() : null;
			delete (priceEl || {}).dataset;

			var row0 = status.querySelector(SEL_QTY_ROW);
			if (row0) row0.remove();
			state.min = 1;
			state.lot = 1;

			var row = document.createElement("div");
			row.className = "fg-variant-qty-row";
			btn.parentNode.insertBefore(row, btn);
			row.appendChild(buildSpinner());
			row.appendChild(btn);

			loadRules(itemCode);
			renderPrice();
			return;
		}

		renderPrice();
	}

	function patchUpdateCart() {
		if (hooked) return;
		var cart = window.webshop && webshop.webshop && webshop.webshop.shopping_cart;
		if (!cart || !cart.update_cart) return;

		var original = cart.update_cart;
		cart.update_cart = function (args) {
			if (args && state.itemCode && args.item_code === state.itemCode) {
				var qty = readQty();
				if (qty > 0) {
					args.qty = qty;
				}
			}
			return original.apply(this, arguments);
		};
		hooked = true;
	}

	function bind() {
		if (!document.querySelector(SEL_STATUS)) return;
		patchUpdateCart();
		ensureSpinner();

		// Eigene Mengen-Steuerung: auf Varianten-Seiten rendert der Webshop
		// seinen Spinner-Handler NICHT (der steckt im Template fuer Artikel
		// ohne Varianten) -> +/- und Eingabe hier selbst fuehren.
		// stopPropagation, damit ein evtl. doch vorhandener delegierter
		// Handler nicht doppelt zaehlt.
		document.addEventListener(
			"click",
			function (e) {
				var btn = e.target && e.target.closest && e.target.closest(SEL_QTY_ROW + " .item-qty-btn");
				if (!btn) return;
				e.stopPropagation();

				var input = spinnerInput();
				if (!input) return;
				var step = parseInt(input.getAttribute("data-lot-size"), 10) || 1;
				var min = parseInt(input.getAttribute("data-min-qty"), 10) || 1;
				var current = parseInt(input.value, 10) || min;

				if (btn.classList.contains("up-qty")) {
					input.value = current + step;
				} else {
					input.value = Math.max(current - step, min);
				}
				renderPrice();
			},
			true
		);

		// Nur Ziffern zulassen, beim Verlassen auf die Mindestmenge ziehen
		document.addEventListener("input", function (e) {
			if (!e.target || !e.target.closest || !e.target.closest(SEL_QTY_ROW)) return;
			var input = e.target;
			input.value = String(input.value).replace(/[^0-9]/g, "");
			renderPrice();
		});
		document.addEventListener("change", function (e) {
			if (!e.target || !e.target.closest || !e.target.closest(SEL_QTY_ROW)) return;
			var input = e.target;
			var min = parseInt(input.getAttribute("data-min-qty"), 10) || 1;
			if (!parseInt(input.value, 10) || parseInt(input.value, 10) < min) {
				input.value = min;
			}
			renderPrice();
		});

		// Variantenwechsel: Statuszeile wird neu aufgebaut
		var statusHost = document.querySelector(".product-page-content") || document.body;
		if (window.MutationObserver) {
			new MutationObserver(function () {
				ensureSpinner();
			}).observe(statusHost, { childList: true, subtree: true });
		}
	}

	function start() {
		bind();
		setTimeout(function () { patchUpdateCart(); ensureSpinner(); }, 400);
		setTimeout(renderPrice, 800);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", start);
	} else {
		start();
	}
})();
